import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#003F74',
        secondary: '#F68D3A',
        accent: '#F68D3A',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#F5F5F5',
        surface: '#FFFFFF',
        sidebar: '#003F74',
        'sidebar-text': '#FFFFFF',
      },
      dark: {
        primary: '#4A90D9',
        secondary: '#F68D3A',
        accent: '#F68D3A',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#121212',
        surface: '#1E1E1E',
        sidebar: '#1E1E1E',
        'sidebar-text': '#FFFFFF',
      },
    },
  },
});
